import { QueryParamFactory } from '../'
import { Uri } from '../../models'

export class UriFactory {
    public create(uri: string): Uri {
      return new Uri(uri, new QueryParamFactory())
    }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/factories/uri/uri.factory.ts